// extracted by mini-css-extract-plugin
export default {"soloButton":"soloButton_soloButton__RwQgb"};